import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  RaisedButton, Card, CardText, Table, TableHeader, TableBody, TableRow, TableHeaderColumn,
  TableRowColumn, CircularProgress,
} from "material-ui";
import DownloadIcon from "material-ui/svg-icons/action/get-app";
import {
  ModalSolicitudReajustePaso, DownloadArancelCompleto, DownloadArancelSeleccionado,
  ModalConsultarPeriodoReajuste,
} from "../SolicitudReajuste/actions";
import styles from "./../../styles/styles";
import TablePaginationCustom from "../../TablePagination/view";
import { LoadingFileArancelCompleto, LoadingFileArancelSeleccionado } from "../FiltroBusqueda/actions";
import PaginacionRA from "../PaginacionReajuste/view";

class ConsultaArancelDetalle extends React.Component {
  state = {
    pagina: 0,
  }

  componentWillMount() {
  }


  ModalSolicitudReajuste = () => {
    this.props.dispatch(ModalSolicitudReajustePaso(1));
  }

  ModalConsultarFechaVigencia = () => {
    this.props.dispatch(ModalConsultarPeriodoReajuste(true));
  }

  DownloadArancelCompleto = () => {
    this.props.dispatch(LoadingFileArancelCompleto(true));
    this.props.dispatch(DownloadArancelCompleto());
  }

  DownloadArancelSeleccionado = () => {
    this.props.dispatch(LoadingFileArancelSeleccionado(true));
    this.props.dispatch(DownloadArancelSeleccionado());
  }

  callbackFunction = (childData) => {
    //console.log("CHILD DATA EN CONSULTA ARANCEL DETALLLE: ", childData);
    this.sendData(childData);
  }

  sendData = (i) => {
    this.props.parentCallback(i);
  }

  render() {
    const menuItemsPrestacionesReajuste = [];

    if (this.props.arancelesDetalle && this.props.arancelesDetalle.length > 0) {
      this.props.arancelesDetalle.map((row, index) => (
        menuItemsPrestacionesReajuste.push((
          <TableRow key={index} >
            <TableRowColumn style={styles.contTablaReajuste1}>{row.CENTRO_AT}</TableRowColumn>
            <TableRowColumn style={styles.contTablaReajuste2}>{row.COD_PRESTADOR}</TableRowColumn>
            <TableRowColumn style={styles.contTablaReajuste3}>{row.GUARISMO}</TableRowColumn>
            <TableRowColumn style={styles.contTablaReajuste4}>{row.GLOSA_CODPRESTADOR}</TableRowColumn>
            <TableRowColumn style={styles.contTablaReajuste5}>{row.COD_ISAPRE}</TableRowColumn>
            <TableRowColumn style={styles.contTablaReajuste6}>{row.TIPO_PRESTACION}</TableRowColumn>
            <TableRowColumn style={styles.contTablaReajuste7}>{row.PROF_CCOD}</TableRowColumn>
            <TableRowColumn style={styles.contTablaReajuste8}>{row.UNIDAD === "PE" ? "$" : null}{row.VALOR}</TableRowColumn>
            <TableRowColumn style={styles.contTablaReajuste9}>{row.TIPO_ATENCION}</TableRowColumn>
            <TableRowColumn style={styles.contTablaReajuste10}>{row.UNIDAD === "VE" ? "VF" : row.UNIDAD}</TableRowColumn>
            <TableRowColumn style={styles.contTablaReajuste11}>{(new Date(row.INICIO_VIG)).toLocaleDateString("en-GB", { timeZone: "UTC" })}</TableRowColumn>
            <TableRowColumn style={styles.contTablaReajuste12}>{row.ITEM_IMED}</TableRowColumn>
          </TableRow>
        ))
      ));
    }
    return (
      <div>
        <div style={{ padding: "5px" }}>
          <Card zDepth={0}>
            <CardText>
              {!this.props.loading ?
                <div className="">
                  {(!this.props.arancelesDetalle) || this.props.arancelesDetalle.length === 0 ?
                    <span style={{ textAlign: "center" }}>No se encontraron resultados</span>
                    :
                    /*<div className="" style={{ overflow: "auto" }}>
                      <div className="" style={{ width: "1700px" }}>
                        {
                          <Table
                            key="tablaConsultaRecargosDetalle"
                            fixedHeader
                            fixedFooter
                            selectable={false}
                            width="1700px"
                          >
                            <TableHeader
                              adjustForCheckbox={false}
                              displaySelectAll={false}
                            >
                              <TableRow selectable={false} >
                                <TableHeaderColumn style={styles.tituloTablaReajuste1} >Centro de Atención</TableHeaderColumn>
                                <TableHeaderColumn style={styles.tituloTablaReajuste2} >Código<br />Prestación Prestador</TableHeaderColumn>
                                <TableHeaderColumn style={styles.tituloTablaReajuste3} >Guarismo de DP o<br />Sala de Procedimiento</TableHeaderColumn>
                                <TableHeaderColumn style={styles.tituloTablaReajuste4} >Glosa<br />Prestación Prestador</TableHeaderColumn>
                                <TableHeaderColumn style={styles.tituloTablaReajuste5} >Código<br />Fonasa / Isapre</TableHeaderColumn>
                                <TableHeaderColumn style={styles.tituloTablaReajuste6} >Tipo de Prestación Isapre</TableHeaderColumn>
                                <TableHeaderColumn style={styles.tituloTablaReajuste7} >Código<br />Profesional Isapre</TableHeaderColumn>
                                <TableHeaderColumn style={styles.tituloTablaReajuste8} >Valor</TableHeaderColumn>
                                <TableHeaderColumn style={styles.tituloTablaReajuste9} >Tipo<br />de Atención</TableHeaderColumn>
                                <TableHeaderColumn style={styles.tituloTablaReajuste10} >Unidad</TableHeaderColumn>
                                <TableHeaderColumn style={styles.tituloTablaReajuste11} >Fecha de<br />Vigencia de precio</TableHeaderColumn>
                                <TableHeaderColumn style={styles.tituloTablaReajuste12} >Item IMED</TableHeaderColumn>
                              </TableRow>
                            </TableHeader>
                            <TableBody
                              displayRowCheckbox={false}
                              deselectOnClickaway={false}
                              showRowHover
                              stripedRows={false}
                              id="tablaBodyConsultaRecargosDetalle"
                            >
                              {!this.props.arancelesDetalle ? <CircularProgress style={{ padding: "50px" }} /> : menuItemsPrestacionesReajuste}
                            </TableBody>
                          </Table>
                        }
                      </div>
                    </div>*/
                    <div>
                      <PaginacionRA
                        parentCallback={this.callbackFunction}
                        idTabla="tablaBusquedaPrestaciones"
                        tipoArancel={this.props.tipoArancel}
                        rutInstitucion={this.props.rutInstitucion}
                        detalleArancel={this.props.arancelesDetalle}
                        isapre={this.props.isapre}
                        key="pag_tablaBodyBusquedaPrestaciones"
                        rowsPerPageDefault={5} // [5,10,15,20,25]
                        totalRows={menuItemsPrestacionesReajuste.length}
                        pageDefault={1}
                        totalPagina={10}
                        idTableBody="tablaBodyConsultaRecargosDetalle"
                        showRowsPerPage={false}
                        labelStyleBtnPage={{ fontSize: "11px" }}
                        overlayStyleBtnPage={{ borderRadius: 20 }}
                        rippleStyleBtnPage={{ borderRadius: 20 }}
                        buttonStyleBtnPage={{ borderRadius: 20 }}
                        styleBtnPage={{
                          paddingLeft: 0,
                          paddingRight: 0,
                          paddingTop: 0,
                          paddingBottom: 0,
                          height: 25,
                          width: "45px",
                          minWidth: "45px",
                          borderRadius: 20,
                          marginRight: 5,
                        }}

                        labelStyleRowsPerPage={styles.h4}
                        underlineStyleRowsPerPage={styles.underlineSelectField}
                        iconStyleRowsPerPage={styles.iconSelectField}
                        menuItemStyleRowsPerPage={styles.menuItemStyleSelectField}
                        selectedMenuItemStyleRowsPerPage={styles.selectedMenuItemSelectField}
                        styleRowsPerPage={styles.selectFiledStyle}
                      />
                    </div>
                  }

                  <div className="row" style={{ marginTop: 20, marginBottom: 20 }}>
                    <div className="col-12" style={{ textAlign: "right" }}>
                      {
                        !this.props.loadingFileArancelCompleto ?
                          <RaisedButton
                            label="Arancel Completo"
                            backgroundColor="#fff"
                            labelPosition="before"
                            overlayStyle={{ borderRadius: 5 }}
                            labelStyle={{
                              fontSize: "11px", color: "#00A100", paddingLeft: 10, paddingRight: 5,
                            }}
                            style={{ width: "190px", borderRadius: 5 }}
                            buttonStyle={{ border: "2px solid #C3C3C3", borderRadius: 5 }}
                            icon={<DownloadIcon />}
                            onClick={this.DownloadArancelCompleto}
                          />
                          :
                          <CircularProgress />
                      }
                      {
                        !this.props.loadingFileArancelSeleccionado ?
                          <RaisedButton
                            label="Arancel Seleccionado"
                            backgroundColor="#fff"
                            labelPosition="before"
                            overlayStyle={{ borderRadius: 5 }}
                            labelStyle={{
                              fontSize: "11px", color: "#00A100", paddingLeft: 10, paddingRight: 5,
                            }}
                            style={{ width: "210px", borderRadius: 5, marginLeft: 20 }}
                            buttonStyle={{ border: "2px solid #C3C3C3", borderRadius: 5 }}
                            icon={<DownloadIcon />}
                            onClick={this.DownloadArancelSeleccionado}
                          />
                          :
                          <CircularProgress />
                      }
                      <RaisedButton
                        label="Continuar"
                        secondary
                        labelStyle={{ fontSize: "11px" }}
                        overlayStyle={{ borderRadius: 5 }}
                        rippleStyle={{ borderRadius: 5 }}
                        style={{ width: "150px", borderRadius: 5, marginLeft: 20 }}
                        buttonStyle={{ borderRadius: 5 }}
                        onClick={this.ModalConsultarFechaVigencia}
                      // onClick={this.ModalSolicitudReajuste}
                      />
                    </div>
                  </div>

                </div>
                :
                <CircularProgress />
              }
            </CardText>
          </Card>
        </div>
      </div>
    );
  }
}

ConsultaArancelDetalle.propTypes = {
  loading: PropTypes.bool.isRequired,
  loadingFileArancelCompleto: PropTypes.bool.isRequired,
  loadingFileArancelSeleccionado: PropTypes.bool.isRequired,
  arancelesDetalle: PropTypes.array.isRequired,
  dispatch: PropTypes.func.isRequired,
  parentCallback: PropTypes.any,
};

const mapStateToProps = (state) => ({
  loading: state.filtroBusquedaRA.loading,
  loadingFileArancelCompleto: state.filtroBusquedaRA.loadingFileArancelCompleto,
  loadingFileArancelSeleccionado: state.filtroBusquedaRA.loadingFileArancelSeleccionado,
  arancelesDetalle: state.filtroBusquedaRA.arancelesDetalle,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});


export default connect(mapStateToProps, mapDispatchToProps)(ConsultaArancelDetalle);

